import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('mapControlPopup');

    return {
        ADD: t('add'),
        DISMISS: t('dismiss'),
        RETICLE_ADD_POINT_CIRCLE: t('reticleAddPointCircle'),
        RETICLE_ADD_POINT_POLYGON: t('reticleAddPointPolygon'),
        TOUCH_ADD_POINT_CIRCLE: t('touchAddPointCircle'),
        TOUCH_ADD_POINT_POLYGON: t('touchAddPointPolygon')
    };
};

export default useTranslation;
